import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {

    constructor(private http: HttpClient, private globals: Globals) { }


    GetScreenName(payload: any): Observable<any> {
        return this.http.post<any>(`${this.globals.APIURL}/AuditLog/GetScreenName`, payload);
    }

    GetDocumentNumber(payload: any): Observable<any> {
        return this.http.post<any>(`${this.globals.APIURL}/AuditLog/GetDocumentNumber`, payload);
    }

    GetAuditLogDetails(payload: any): Observable<any> {
        return this.http.post<any>(`${this.globals.APIURL}/AuditLog/GetAuditLogDetails`, payload);
    }

}
